import React, { useState, useEffect, useLayoutEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ParentNavbar from "./ParentNavbar";
import bgLight from "../../assets/bg001.png";
import bgDark from "../../assets/bg002.png";
import useSystemDarkMode from "../../utils/useDarkMode";
import useBackendStatus from "../../utils/useBackendStatus";
import { analyticsIdsFromPathname } from "../../analytics/analyticsIds";
import { ParentChromeContext } from "./parentChrome";


const ParentPortalLayout = () => {
    // const [darkMode, setDarkMode] = useState(() => window.matchMedia("(prefers-color-scheme: dark)").matches);
    const {darkMode, setDarkMode} = useSystemDarkMode();
    const online = useBackendStatus(); // ✅
    const location = useLocation();
    // The outage page hides the top bar (see useHideParentNavbar).
    const [navbarHidden, setNavbarHidden] = useState(false);
    const chrome = useMemo(() => ({ setNavbarHidden }), []);

    useEffect(() => {
        document.body.classList.add("parent-portal");
        document.documentElement.classList.add("parent-portal-shell");
        return () => {
            document.body.classList.remove("parent-portal");
            document.documentElement.classList.remove("parent-portal-shell");
        };
    }, []);

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("parent-portal-dark");
            document.documentElement.classList.add("parent-portal-dark");
        } else {
            document.body.classList.remove("parent-portal-dark");
            document.documentElement.classList.remove("parent-portal-dark");
        }
        return () => {
            document.body.classList.remove("parent-portal-dark");
            document.documentElement.classList.remove("parent-portal-dark");
        };
    }, [darkMode]);

    useLayoutEffect(() => {
        try {
            if (typeof window === "undefined") return;
            const ids = analyticsIdsFromPathname(location.pathname);
            window.__LUMEN_PAGE_ID__ = ids?.page || null;
            window.__LUMEN_FEATURE_ID__ = ids?.feature || null;
        } catch {
            // ignore
        }
    }, [location.pathname]);

    return (
        <div
            className={`${darkMode ? "dark" : ""} relative isolate flex min-h-screen min-w-0 max-w-full flex-col overflow-x-hidden font-sans transition`}
            style={{
                "--parent-portal-theme": "#047857",
                "--parent-portal-theme-soft": "#d1fae5",
                "--parent-portal-theme-dark": "#065f46",
            }}
        >
            <div
                className="fixed inset-0 -z-10"
                style={{
                    backgroundImage: `url(${darkMode ? bgDark : bgLight})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
                aria-hidden="true"
            />
            <img src={bgDark} alt="" className="hidden" aria-hidden="true"/>
            <img src={bgLight} alt="" className="hidden" aria-hidden="true"/>
            <div className="relative z-0 flex min-w-0 flex-1 flex-col px-0 py-4 transition sm:px-6 sm:py-6 lg:px-12 lg:py-8">
                {!navbarHidden && (
                <div className="hidden lg:flex flex-col gap-2 sm:gap-4">
                    <div className="w-full max-w-5xl self-center px-2 sm:px-4">
                        <ParentNavbar
                        darkMode={darkMode}
                        setDarkMode={setDarkMode}
                        backendOnline={online}
                        />
                    </div>
                </div>
                )}

                <main className="mt-0 lg:mt-3 flex flex-1 flex-col">
                <div className="flex flex-1 justify-center pb-4 sm:pb-6">
                        <div className="min-w-0 w-full max-w-5xl px-0 sm:px-4">
                            <ParentChromeContext.Provider value={chrome}>
                                <Outlet/>
                            </ParentChromeContext.Provider>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default ParentPortalLayout;
